import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DynamicFormValuesSections, FinancialSummary } from '@app/models';
import { FinancialService } from '@app/services';
import { AppInfoService } from '@app/services/app-info.service';
import { NgxMaskPipe } from 'ngx-mask';

@Component({
  selector: 'qb-questionnaire-summary',
  templateUrl: './questionnaire-summary.component.html',
  styleUrls: ['./questionnaire-summary.component.scss'],
  imports: [CurrencyPipe, NgxMaskPipe],
})
export class QuestionnaireSummaryComponent implements OnInit {
  @Input() questionnaireValues: DynamicFormValuesSections;

  questionnaireSummary: FinancialSummary;
  hideSummary: boolean = true;

  private revenues = Array<number>();

  private get minGrossRevenue(): number {
    const min = this.revenues.indexOf(Math.min(...this.revenues));
    return this.revenues[min];
  }

  private get maxGrossRevenue(): number {
    const max = this.revenues.indexOf(Math.max(...this.revenues));
    return this.revenues[max];
  }

  private get averageGrossRevenue(): number {
    return (
      this.revenues.reduce((sum, num) => {
        return sum + num;
      }, 0) / this.revenues.length
    );
  }

  constructor(
    private financialServices: FinancialService,
    private app: AppInfoService
  ) {}

  ngOnInit(): void {
    this.financialServices.getFinancialSummary(this.app.id).subscribe({
      next: res => {
        this.questionnaireSummary = {
          appNumber: res.appNumber,
          firmName: res.firmName,
          contactPerson: res.contactPerson,
          contactEmail: res.contactEmail,
          contactPhone: res.contactPhone,
          bondingCapacity: res.bondingCapacity,
          minGrossRevenue: res.minGrossRevenue,
          maxGrossRevenue: res.maxGrossRevenue,
          averageGrossRevenue: res.averageGrossRevenue,
        };
        this.hideSummary = false;
      },
      error: () => {
        this.hideSummary = true;
      },
    });
  }
}
